import { Card, CardContent } from "@/components/ui/card";
import ArOfficeStaffPayslipForm from "@/v2/components/pages/payslip/ar-office-staff/Form";
import FormPageHeading from "@/v2/components/ui/heading/FormPage";
import { ReceiptTextIcon } from "lucide-react";

export default function AddArOfficeStaffPayslipPage() {
    return (
        <div className="my-3 min-h-screen">
            <Card className="rounded-xl border-slate-200 shadow-lg dark:border-slate-700">
                <FormPageHeading
                    title="Payslip Management"
                    description="Create and manage employee payslips"
                    Icon={ReceiptTextIcon}
                />
                <CardContent className="pt-6">
                    <ArOfficeStaffPayslipForm />
                </CardContent>
            </Card>
        </div>
    );
}
